import { create } from 'zustand';

/** Login-page scene reactions: the sign-in form reports auth attempts and the
 *  animated EpcLoginScene responds (error → the crane holds mid-lift and the
 *  tag-line rigger fidgets; success → the turbine completes and blades spin
 *  up). Pure client UI state — reset to 'idle' whenever a new attempt starts. */
export type AuthSceneState = 'idle' | 'error' | 'success';

interface AuthSceneStore {
  state: AuthSceneState;
  setState: (state: AuthSceneState) => void;
}

export const useAuthSceneStore = create<AuthSceneStore>((set) => ({
  state: 'idle',
  setState: (state) => set({ state }),
}));
